// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"b9217e34","39":"f972ef21","62":"9591ddd5","265":"d9ab1d71","273":"46c94a84","331":"2ecac6ca","419":"6026a671","593":"07a5ed64","668":"df07a4fb","882":"d4e2dc34","972":"8070d8cd"}[chunkId] + ".chunk.js";
};